<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  updated() {},
  destroyed() {},
};
</script>

<style lang="less" scoped></style>
